import { common as trCommon } from './tr/common';
import { common as enCommon } from './en/common';
import { common as deCommon } from './de/common';

export const resources = {
  tr: {
    common: trCommon
  },
  en: {
    common: enCommon
  },
  de: {
    common: deCommon
  }
};
